import React from 'react'

export default function DashboardHeader() {
  return (
    <div style={{ 
      textAlign: 'center', 
      marginBottom: '2rem',
      borderBottom: '3px solid #007bff',
      paddingBottom: '1rem'
    }}>
      <h1 style={{ 
        color: '#2c3e50', 
        marginBottom: '0.5rem',
        fontSize: '2.5rem'
      }}>
        Ocean pCO₂ Monitor
      </h1>
      <p style={{ 
        color: '#6c757d', 
        fontSize: '1.2rem',
        margin: 0
      }}>
        Real-time ocean carbon dioxide monitoring for climate research
      </p>
    </div>
  )
}